<template>
  <el-card class="product-prices mb-4" shadow="hover">
    <div slot="header" class="d-flex justify-content-between align-items-center">
      <span class="font-weight-bold title">2. Cấu hình giá (Prices)</span>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openCreateDialog">
        Thêm cấu hình giá
      </el-button>
    </div>

    <el-table v-loading="loading" :data="priceList" border style="width: 100%;">
      <el-table-column type="index" label="STT" width="70" align="center" />
      <el-table-column prop="type" label="Loại cấu hình">
        <template slot-scope="scope">
          <el-tag :type="getTypeTag(scope.row.type)">
            {{ getTypeName(scope.row.type) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="value" label="Giá trị">
        <template slot-scope="scope">
          <strong style="color: #409EFF;">
            {{ scope.row.value }} {{ scope.row.value_type === 'percent' || !scope.row.value_type ? '%' : '' }}
          </strong>
        </template>
      </el-table-column>
      <el-table-column label="Thao tác" width="100" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #F56C6C;"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >
            Xóa
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Dialog Thêm mới cấu hình giá -->
    <el-dialog
      title="Thêm Cấu Hình Giá"
      :visible.sync="dialogVisible"
      width="450px"
      append-to-body
    >
      <el-form ref="form" v-loading="submitting" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="Loại cấu hình" prop="type">
          <el-select v-model="form.type" style="width: 100%;">
            <el-option label="Markup (Tăng giá)" value="markup" />
            <el-option label="Promotion (Khuyến mãi)" value="promotion" />
            <el-option label="Tax (Thuế)" value="tax" />
          </el-select>
        </el-form-item>

        <el-form-item label="Giá trị (%)" prop="value">
          <el-input-number v-model="form.value" :min="0" style="width: 100%;" placeholder="Nhập giá trị (%)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Hủy</el-button>
        <el-button type="primary" :loading="submitting" @click="handleCreate">Thêm mới</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { getPrices, createPrice, deletePrice } from '@/services/product'

export default {
  name: 'ProductPrices',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      priceList: [],
      form: {
        type: 'markup',
        applies_to: 'product',
        applies_to_value: '',
        value: 0,
        value_type: 'percent',
        priority: 1,
        active: true
      },
      rules: {
        type: [{ required: true, message: 'Vui lòng chọn loại', trigger: 'change' }],
        value: [{ required: true, message: 'Vui lòng nhập giá trị', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.fetchPrices()
  },
  methods: {
    getProductId() {
      return this.product.id || this.product._id
    },
    getTypeTag(type) {
      if (type === 'markup') return 'warning'
      if (type === 'promotion') return 'success'
      if (type === 'tax') return 'info'
      return ''
    },
    getTypeName(type) {
      if (type === 'markup') return 'Markup (Tăng giá)'
      if (type === 'promotion') return 'Promotion (Khuyến mãi)'
      if (type === 'tax') return 'Tax (Thuế)'
      return type || '-'
    },
    fetchPrices() {
      const productId = this.getProductId()
      if (!productId) return
      this.loading = true
      getPrices({ applies_to_value: productId }).then((res) => {
        const data = res.data || res
        this.priceList = Array.isArray(data) ? data : (data.items || data.list || [])
      }).catch(() => {
        this.priceList = []
      }).finally(() => {
        this.loading = false
      })
    },
    openCreateDialog() {
      this.form = {
        type: 'markup',
        applies_to: 'product',
        applies_to_value: this.getProductId(),
        value: 0,
        value_type: 'percent',
        priority: 1,
        active: true
      }
      this.dialogVisible = true
    },
    handleCreate() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitting = true
        createPrice(this.form).then(() => {
          this.$message.success('Thêm cấu hình giá thành công!')
          this.dialogVisible = false
          this.fetchPrices()
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Lỗi khi tạo cấu hình giá'
          this.$message.error(errMsg)
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    handleDelete(row) {
      this.$confirm('Bạn có chắc chắn muốn xóa cấu hình giá này?', 'Xác nhận xóa', {
        type: 'warning'
      }).then(() => {
        const priceId = row.id || row._id
        deletePrice(priceId).then(() => {
          this.$message.success('Xóa cấu hình giá thành công!')
          this.fetchPrices()
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Không thể xóa giá'
          this.$message.error(errMsg)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.product-prices .title {
  font-size: 16px;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.align-items-center {
  align-items: center;
}
</style>
